"use client";
import { MutableRefObject, RefObject } from "react";
import { View } from "react-native";
import GatheringViewMethod from "src/api/graphql/__generated__/enums/GatheringViewMethod";
import AnimatedAboveKeyboard from "src/components/AnimatedAboveKeyboard";
import MarkGatheringViewed from "src/components/MarkGatheringViewed";
import OpacityView from "src/components/OpacityView";
import RoundedButton from "src/components/RoundedButton";
import Touchable from "src/components/Touchable";
import { parseGatheringThumbnailUrl } from "src/constants/GatheringThumbnail";
import useRouter from "src/hooks/useRouter";
import { radiusMedium } from "src/styles/radius";
import { paddingLarge, paddingMedium, paddingSmall, paddingXL } from "src/styles/spacing";
import { Image, Text, TextInput, TextInputHandler } from "src/swsh-native";
import { GatheringPreviewSubPageProps } from "../types";

const GatheringPreviewPrivate = ({
	gathering,
	handleJoinGathering,
	joinLoading: loading,
	passwordRef,
	textRef,
	displayPassword,
	shouldDisplayUnlock,
}: GatheringPreviewSubPageProps & {
	textRef: RefObject<TextInputHandler>;
	passwordRef: MutableRefObject<string>;
	displayPassword: boolean;
	shouldDisplayUnlock: boolean | undefined;
}) => {
	const router = useRouter();
	const thumbnailUrl = parseGatheringThumbnailUrl({
		readUrl: gathering.thumbnail?.readUrl,
	});

	return (
		<>
			<MarkGatheringViewed
				gatheringId={gathering.gatheringId}
				method={GatheringViewMethod.Restricted}
			/>
			<AnimatedAboveKeyboard
				style={{
					height: "100%",
					justifyContent: "center",
					alignItems: "center",
					paddingHorizontal: paddingLarge,
				}}
			>
				<View
					testID="GatheringPreviewPrivate"
					style={{
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Text
						testID="AlbumName"
						semibold
						sl
						style={[
							{
								marginTop: paddingSmall,
								marginBottom: paddingXL,
								textAlign: "center",
							},
						]}
					>
						{gathering.name}
					</Text>
					<View
						style={{
							width: 220,
						}}
					>
						<View
							style={{
								width: "100%",
								aspectRatio: 3 / 4,
							}}
						>
							{!!thumbnailUrl && (
								<Image
									alt="Album thumbnail"
									src={thumbnailUrl}
									dim="auto"
									style={{
										borderRadius: radiusMedium,
										width: "100%",
										height: "100%",
									}}
								/>
							)}
						</View>
						{displayPassword && (
							<OpacityView>
								<TextInput
									ref={textRef}
									style={{
										marginTop: paddingLarge,
										paddingVertical: paddingMedium,
										paddingHorizontal: paddingMedium,
										textAlign: "center",
									}}
									onChangeText={(text) => {
										passwordRef.current = text;
									}}
									placeholder="Password"
									secureTextEntry
									onSubmitEditing={handleJoinGathering}
									autoFocus
								/>
							</OpacityView>
						)}
						<RoundedButton
							containerStyle={{
								marginTop: paddingLarge,
							}}
							sizeVariant="Flex"
							colorVariant="Contrast"
							loading={loading}
							onPress={handleJoinGathering}
							roundRadius="Medium"
						>
							{shouldDisplayUnlock || displayPassword ? "Unlock album" : "Join album"}
						</RoundedButton>
						<Touchable
							containerStyle={{
								marginTop: paddingLarge,
								alignSelf: "center",
								padding: paddingLarge,
							}}
							onPress={() => {
								router.push("/home");
							}}
						>
							<Text color="TextLight">Ignore album</Text>
						</Touchable>
					</View>
				</View>
			</AnimatedAboveKeyboard>
		</>
	);
};
export default GatheringPreviewPrivate;
